import { useEffect, useState } from "react";
import { vocabularize } from "src/Common/vocab";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { Tooltip } from "react-tooltip";
import moment from "moment";
import { can, handleError, isAllAccessRoleName } from "src/Common/function";
import RoleService from "src/Services/API/role.service";
import ConfirmDialog from "src/Common/confirmdialog";
import Loader from "src/Components/Common/Loader";
import CreateRoleModal from "./CreateRoleModal";

const PAGE_SIZE = 9;

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 2.83334C8.32217 2.83334 8.58334 3.09451 8.58334 3.41668V7.41668H12.5833C12.9055 7.41668 13.1667 7.67784 13.1667 8.00001C13.1667 8.32218 12.9055 8.58334 12.5833 8.58334H8.58334V12.5833C8.58334 12.9055 8.32217 13.1667 8 13.1667C7.67783 13.1667 7.41667 12.9055 7.41667 12.5833V8.58334H3.41667C3.0945 8.58334 2.83334 8.32218 2.83334 8.00001C2.83334 7.67784 3.0945 7.41668 3.41667 7.41668H7.41667V3.41668C7.41667 3.09451 7.67783 2.83334 8 2.83334Z"
      fill="white"
    />
  </svg>
);

const TotalRolesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M14.375 17.5C14.375 16.3397 13.9137 15.2272 13.0933 14.4067C12.2728 13.5863 11.1603 13.125 10 13.125C8.83968 13.125 7.72721 13.5863 6.90674 14.4067C6.08627 15.2272 5.625 16.3397 5.625 17.5C5.625 17.8452 5.34518 18.125 5 18.125C4.65482 18.125 4.375 17.8452 4.375 17.5C4.375 16.0082 4.96724 14.577 6.02214 13.5221C7.07703 12.4672 8.50816 11.875 10 11.875C11.4918 11.875 12.923 12.4672 13.9779 13.5221C15.0328 14.577 15.625 16.0082 15.625 17.5C15.625 17.8452 15.3452 18.125 15 18.125C14.6548 18.125 14.375 17.8452 14.375 17.5Z"
      fill="#0058E5"
    />
    <path
      d="M12.7083 9.16667C12.7083 7.6709 11.4958 6.45833 10 6.45833C8.50423 6.45833 7.29167 7.6709 7.29167 9.16667C7.29167 10.6624 8.50423 11.875 10 11.875C11.4958 11.875 12.7083 10.6624 12.7083 9.16667ZM13.9583 9.16667C13.9583 11.3528 12.1861 13.125 10 13.125C7.81387 13.125 6.04167 11.3528 6.04167 9.16667C6.04167 6.98054 7.81387 5.20833 10 5.20833C12.1861 5.20833 13.9583 6.98054 13.9583 9.16667Z"
      fill="#0058E5"
    />
    <path
      d="M16.875 4.16667C16.875 3.59137 16.4086 3.125 15.8333 3.125H4.16667C3.59137 3.125 3.125 3.59137 3.125 4.16667V15.8333C3.125 16.4086 3.59137 16.875 4.16667 16.875H15.8333C16.4086 16.875 16.875 16.4086 16.875 15.8333V4.16667ZM18.125 15.8333C18.125 17.099 17.099 18.125 15.8333 18.125H4.16667C2.90101 18.125 1.875 17.099 1.875 15.8333V4.16667C1.875 2.90101 2.90101 1.875 4.16667 1.875H15.8333C17.099 1.875 18.125 2.90101 18.125 4.16667V15.8333Z"
      fill="#0058E5"
    />
  </svg>
);

const RolesInUseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M16.0417 8.33366C16.0417 6.73131 15.4055 5.19423 14.2725 4.0612C13.1395 2.92817 11.6024 2.29199 10 2.29199C8.39769 2.29199 6.86061 2.92817 5.72758 4.0612C4.59455 5.19423 3.95837 6.73131 3.95837 8.33366C3.95837 10.2033 5.00714 12.1892 6.33223 13.9302C7.62684 15.6311 9.11179 17.0037 9.8796 17.6688C9.91489 17.694 9.95659 17.7087 10 17.7087C10.0433 17.7087 10.0845 17.6937 10.1197 17.6688C10.8873 17.0038 12.373 15.6314 13.6678 13.9302C14.9929 12.1892 16.0417 10.2033 16.0417 8.33366ZM17.2917 8.33366C17.2917 10.6248 16.0326 12.8866 14.6623 14.687C13.2775 16.5064 11.6998 17.9561 10.9091 18.6388C10.8984 18.648 10.8877 18.6572 10.8765 18.6657C10.6238 18.8557 10.3162 18.9587 10 18.9587C9.68388 18.9587 9.37627 18.8557 9.12358 18.6657C9.11234 18.6572 9.10167 18.648 9.09102 18.6388C8.30029 17.9561 6.72254 16.5064 5.33777 14.687C3.96744 12.8866 2.70837 10.6248 2.70837 8.33366C2.70837 6.39979 3.47634 4.54486 4.84379 3.17741C6.21124 1.80996 8.06617 1.04199 10 1.04199C11.9339 1.04199 13.7888 1.80996 15.1563 3.17741C16.5237 4.54486 17.2917 6.39979 17.2917 8.33366ZM11.875 8.33366C11.875 7.29812 11.0356 6.45866 10 6.45866C8.96451 6.45866 8.12504 7.29812 8.12504 8.33366C8.12504 9.36919 8.96451 10.2087 10 10.2087C11.0356 10.2087 11.875 9.36919 11.875 8.33366ZM13.125 8.33366C13.125 10.0595 11.7259 11.4587 10 11.4587C8.27415 11.4587 6.87504 10.0595 6.87504 8.33366C6.87504 6.60777 8.27415 5.20866 10 5.20866C11.7259 5.20866 13.125 6.60777 13.125 8.33366Z"
      fill="#C2410C"
    />
  </svg>
);

const AssignedUsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M1.04163 17.4996C1.04163 16.0965 1.4467 14.7233 2.2078 13.5446C2.96906 12.3656 4.05455 11.4307 5.33362 10.8533C6.61259 10.2761 8.03133 10.0805 9.4189 10.2893C10.8064 10.4983 12.1044 11.1027 13.1567 12.0309C13.4155 12.2591 13.4401 12.6542 13.212 12.913C12.9837 13.1719 12.5887 13.1967 12.3299 12.9684C11.4579 12.1993 10.3823 11.6986 9.23254 11.5255C8.08287 11.3525 6.90763 11.5144 5.84794 11.9926C4.78814 12.471 3.88837 13.2456 3.25761 14.2224C2.627 15.1991 2.29163 16.3371 2.29163 17.4996C2.29164 17.8448 2.0118 18.1246 1.66663 18.1246C1.32146 18.1246 1.04164 17.8448 1.04163 17.4996Z"
      fill="#15803D"
    />
    <path
      d="M11.875 6.66667C11.875 4.71066 10.2893 3.125 8.33329 3.125C6.37728 3.125 4.79163 4.71066 4.79163 6.66667C4.79163 8.62267 6.37728 10.2083 8.33329 10.2083C10.2893 10.2083 11.875 8.62267 11.875 6.66667ZM13.125 6.66667C13.125 9.31303 10.9797 11.4583 8.33329 11.4583C5.68693 11.4583 3.54163 9.31303 3.54163 6.66667C3.54163 4.0203 5.68693 1.875 8.33329 1.875C10.9797 1.875 13.125 4.0203 13.125 6.66667Z"
      fill="#15803D"
    />
    <path
      d="M17.8914 13.7248C18.1355 13.4807 18.5311 13.4807 18.7752 13.7248C19.0193 13.9689 19.0193 14.3645 18.7752 14.6086L15.4419 17.9419C15.1978 18.186 14.8021 18.186 14.5581 17.9419L12.8914 16.2752C12.6473 16.0311 12.6473 15.6355 12.8914 15.3914C13.1355 15.1474 13.5311 15.1474 13.7752 15.3914L15 16.6162L17.8914 13.7248Z"
      fill="#15803D"
    />
  </svg>
);

const DotsVerticalIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 4.5C8.82843 4.5 9.5 3.82843 9.5 3C9.5 2.17157 8.82843 1.5 8 1.5C7.17157 1.5 6.5 2.17157 6.5 3C6.5 3.82843 7.17157 4.5 8 4.5ZM8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5ZM9.5 13C9.5 13.8284 8.82843 14.5 8 14.5C7.17157 14.5 6.5 13.8284 6.5 13C6.5 12.1716 7.17157 11.5 8 11.5C8.82843 11.5 9.5 12.1716 9.5 13Z"
      fill="currentColor"
    />
  </svg>
);

const ManagePoliciesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.5L13.5 3.83333V7.16667C13.5 10.64 11.1667 13.88 8 14.6667C4.83333 13.88 2.5 10.64 2.5 7.16667V3.83333L8 1.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M11.3333 2.00004C11.5085 1.82494 11.7163 1.68605 11.9451 1.59129C12.1739 1.49653 12.4191 1.44775 12.6667 1.44775C12.9143 1.44775 13.1595 1.49653 13.3883 1.59129C13.617 1.68605 13.8249 1.82494 14 2.00004C14.1751 2.17513 14.314 2.383 14.4088 2.61178C14.5035 2.84055 14.5523 3.08575 14.5523 3.33337C14.5523 3.58099 14.5035 3.82619 14.4088 4.05497C14.314 4.28374 14.1751 4.49161 14 4.66671L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00004Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2 4H14M12.6667 4V13.3333C12.6667 14 12 14.6667 11.3333 14.6667H4.66667C4 14.6667 3.33333 14 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 2 6 1.33333 6.66667 1.33333H9.33333C10 1.33333 10.6667 2 10.6667 2.66667V4M6.66667 7.33333V11.3333M9.33333 7.33333V11.3333"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

function StatCard({ label, value, icon, tileBg }) {
  return (
    <div className="flex-1 self-stretch bg-white rounded-[12px] outline outline-1 outline-offset-[-1px] outline-[#E5E8F3] px-5 py-8 flex items-center gap-2">
      <div className="flex-1 flex flex-col items-start gap-[2px]">
        <div className="text-[#7C829A] font-OpenSansSemiBold text-[14px] leading-5 tracking-[0.14px] capitalize">
          {label}
        </div>
        <div className="text-[#1A2332] font-OpenSansSemiBold text-[24px] leading-8 capitalize">{value}</div>
      </div>
      <div className="w-10 h-10 rounded-[11.43px] flex items-center justify-center" style={{ background: tileBg }}>
        {icon}
      </div>
    </div>
  );
}

/**
 * Roles list — the IAM "Roles" page. Stats cards, searchable/paginated table
 * with Active Branches, Attached Policies, Users and Last Updated, plus
 * create/edit/delete and CSV export.
 */
function Roles() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [stats, setStats] = useState({ total: 0, rolesInUse: 0, customRoles: 0, assignedUsers: 0 });
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [menuOpenId, setMenuOpenId] = useState(null);

  // create/edit modal state
  const [modalShown, setModalShown] = useState(false);
  const [editingRole, setEditingRole] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const load = () => {
    setIsLoading(true);
    Promise.all([RoleService.getManageList(), RoleService.getStats()])
      .then(([listRes, statsRes]) => {
        setRoles(listRes.data ?? []);
        setStats(statsRes.data ?? {});
      })
      .catch(handleError)
      .finally(() => setIsLoading(false));
  };

  useEffect(load, []);

  const totalPages = Math.max(1, Math.ceil(roles.length / PAGE_SIZE));
  const pageRoles = roles.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  useEffect(() => {
    if (page > totalPages) setPage(1);
  }, [totalPages, page]);

  const openCreate = () => {
    setEditingRole(null);
    setModalShown(true);
  };
  const openEdit = (role) => {
    setEditingRole(role);
    setModalShown(true);
    setMenuOpenId(null);
  };
  const doDelete = (role) => {
    setMenuOpenId(null);
    setDeleteTarget(role);
  };

  const confirmDelete = () => {
    RoleService.remove(deleteTarget.id)
      .then(() => {
        toast("Role deleted");
        load();
      })
      .catch(handleError);
    setDeleteTarget(null);
  };

  const exportCsv = () => {
    const header = ["Role Name", "Active Branches", "Attached Policies", "Users", "Last Updated"];
    const esc = (v) => {
      const s = String(v ?? "");
      return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
    };
    const rows = roles.map((r) =>
      [
        r.name,
        r.activeBranchCount,
        // Matches the table: a count would read as "no access" for a role that
        // grants everything.
        isAllAccessRoleName(r.name) ? "Full access" : r.policyCount,
        r.userCount,
        r.updatedAt ? moment(r.updatedAt).format("YYYY-MM-DD HH:mm") : "",
      ]
        .map(esc)
        .join(","),
    );
    const csv = "﻿" + [header.join(","), ...rows].join("\r\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "roles.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="px-7 py-6">
      {/* Stats cards */}
      <div className="flex gap-4 mb-5">
        <StatCard label="Total Roles" value={stats.total} icon={<TotalRolesIcon />} tileBg="#DAEBFF" />
        <StatCard label="Roles In Use" value={stats.rolesInUse} icon={<RolesInUseIcon />} tileBg="#FFEDD5" />
        <StatCard label="Assigned Users" value={stats.assignedUsers} icon={<AssignedUsersIcon />} tileBg="#DCFCE7" />
      </div>

      <div className="flex items-center justify-end gap-2 mb-3">
        <button
          onClick={exportCsv}
          className="h-8 px-3 inline-flex items-center justify-center gap-2 rounded-[8px] bg-white shadow-[0px_1px_2px_rgba(16,24,40,0.05)] outline outline-1 outline-offset-[-1px] outline-[#C9CEE2] text-[14px] leading-5 tracking-[0.14px] capitalize font-OpenSansSemiBold text-[#1A2332] hover:bg-[#F8F9FE]"
        >
          <img
            src="/images/common/download.svg"
            alt=""
            className="h-[16px] w-[16px] [filter:brightness(0)_saturate(100%)_invert(11%)_sepia(18%)_saturate(1974%)_hue-rotate(184deg)_brightness(94%)_contrast(93%)]"
          />
          Export List
        </button>
        {can("iam:createRole") && (
          <button
            onClick={openCreate}
            className="h-8 px-3 inline-flex items-center justify-center gap-2 rounded-[8px] bg-[#0065FD] text-[14px] leading-5 tracking-[0.14px] capitalize font-OpenSansSemiBold text-white hover:bg-[#0048bd]"
          >
            <PlusIcon />
            Create Role
          </button>
        )}
      </div>

      <div className="bg-white rounded-[12px] outline outline-1 outline-offset-[-1px] outline-[#E5E8F3] shadow-[0px_1px_2px_rgba(0,0,0,0.06)] overflow-visible">
        <div className="grid grid-cols-[2fr_1.2fr_1fr_1fr_1.2fr_40px] px-6 h-11 bg-[#F8F9FE] border-b border-[#E5E8F3] items-center">
          <span className="text-[12px] leading-[18px] font-OpenSansSemiBold text-[#5F6477]">
            Role Name
          </span>
          <span className="text-[12px] leading-[18px] font-OpenSansSemiBold text-[#5F6477] flex items-center gap-1">
            Active Branches
            <span
              data-tooltip-id="roles-active-branches"
              data-tooltip-content="Distinct branches across the users who currently hold this role."
              className="cursor-help text-[#7C829A] flex items-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8Z"
                  fill="currentColor"
                />
                <path
                  d="M8 7C8.27614 7 8.5 7.22386 8.5 7.5V11.1667C8.5 11.4428 8.27614 11.6667 8 11.6667C7.72386 11.6667 7.5 11.4428 7.5 11.1667V7.5C7.5 7.22386 7.72386 7 8 7Z"
                  fill="currentColor"
                />
                <path
                  d="M8.66667 5.16667C8.66667 5.53486 8.36819 5.83333 8 5.83333C7.63181 5.83333 7.33333 5.53486 7.33333 5.16667C7.33333 4.79848 7.63181 4.5 8 4.5C8.36819 4.5 8.66667 4.79848 8.66667 5.16667Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <Tooltip
              id="roles-active-branches"
              positionStrategy="fixed"
              className="!max-w-[260px] !rounded-[8px] !bg-[#1A2332] !px-3 !py-2 !text-[11px] !font-OpenSansRegular !leading-[16px]"
            />
          </span>
          <span className="text-[12px] leading-[18px] font-OpenSansSemiBold text-[#5F6477]">
            Attached Policies
          </span>
          <span className="text-[12px] leading-[18px] font-OpenSansSemiBold text-[#5F6477]">Users</span>
          <span className="text-[12px] leading-[18px] font-OpenSansSemiBold text-[#5F6477]">
            Last Updated
          </span>
          <span />
        </div>

        {isLoading ? (
          <Loader variant="block" className="px-6 py-10" ariaLabel="loading-roles" />
        ) : pageRoles.length === 0 ? (
          <div className="px-6 py-10 text-center text-[#868DA6] font-OpenSansRegular">No roles found.</div>
        ) : (
          pageRoles.map((role) => (
            <div
              key={role.id}
              onClick={() => navigate(`/roles/${role.id}`)}
              className="grid grid-cols-[2fr_1.2fr_1fr_1fr_1.2fr_40px] px-6 h-[72px] border-b border-[#E5E8F3] last:border-b-0 cursor-pointer hover:bg-[#F8F9FE] items-center"
            >
              <div>
                <p className="text-[14px] leading-5 font-OpenSansSemiBold text-[#1A2332] capitalize">{vocabularize(role.name)}</p>
                {role.description && (
                  <p className="text-[12px] font-OpenSansRegular text-[#868DA6]">{vocabularize(role.description)}</p>
                )}
              </div>
              <span className="text-[14px] leading-5 tracking-[0.14px] font-OpenSansRegular text-[#5F6477] flex items-center gap-1.5">
                {role.activeBranchCount} {role.activeBranchCount === 1 ? "Branch" : "Branches"}
              </span>
              <span className="text-[14px] leading-5 tracking-[0.14px] font-OpenSansRegular text-[#5F6477]">
                {isAllAccessRoleName(role.name)
                  ? "Full access"
                  : `${role.policyCount} ${role.policyCount === 1 ? "Policy" : "Policies"}`}
              </span>
              <span className="text-[14px] leading-5 tracking-[0.14px] font-OpenSansRegular text-[#5F6477]">
                {role.userCount} {role.userCount === 1 ? "User" : "Users"}
              </span>
              <span className="text-[14px] leading-5 tracking-[0.14px] font-OpenSansRegular text-[#5F6477]">
                {role.updatedAt ? moment(role.updatedAt).fromNow() : "—"}
              </span>
              <span className="relative flex justify-end" onClick={(e) => e.stopPropagation()}>
                <button
                  onClick={() => setMenuOpenId(menuOpenId === role.id ? null : role.id)}
                  className={`w-8 h-8 rounded-[8px] flex items-center justify-center transition-colors ${
                    menuOpenId === role.id
                      ? "bg-[#EEF0F7] text-[#1A2332]"
                      : "text-[#868DA6] hover:bg-[#EEF0F7] hover:text-[#1A2332]"
                  }`}
                  title="Actions"
                >
                  <DotsVerticalIcon />
                </button>
                {menuOpenId === role.id && (
                  <OutsideClickHandler onOutsideClick={() => setMenuOpenId(null)}>
                    <div className="absolute right-0 top-9 z-20 w-[184px] bg-white rounded-[10px] outline outline-1 outline-offset-[-1px] outline-[#E5E8F3] shadow-[0px_8px_24px_rgba(16,24,40,0.12)] p-1">
                      {/* Nothing to manage on an all-access role: it grants
                          everything by name, whatever is attached. */}
                      {!isAllAccessRoleName(role.name) && (
                        <button
                          onClick={() => navigate(`/roles/${role.id}`)}
                          className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-[6px] text-[13px] leading-5 font-OpenSansMedium text-[#1A2332] hover:bg-[#F5F9FF] hover:text-[#0065FD]"
                        >
                          <ManagePoliciesIcon />
                          Manage Policies
                        </button>
                      )}
                      {can("iam:updateRole") && (
                        <button
                          onClick={() => openEdit(role)}
                          className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-[6px] text-[13px] leading-5 font-OpenSansMedium text-[#1A2332] hover:bg-[#F5F9FF] hover:text-[#0065FD]"
                        >
                          <EditIcon />
                          Edit
                        </button>
                      )}
                      {role.name !== "Super Admin" && can("iam:deleteRole") && (
                        <>
                          <div className="my-1 h-px bg-[#E5E8F3]" />
                          <button
                            onClick={() => doDelete(role)}
                            className="w-full flex items-center gap-2.5 px-2.5 py-2 rounded-[6px] text-[13px] leading-5 font-OpenSansMedium text-[#D93A3A] hover:bg-[#FDEAEA]"
                          >
                            <TrashIcon />
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  </OutsideClickHandler>
                )}
              </span>
            </div>
          ))
        )}

        {/* Pagination */}
        {!isLoading && roles.length > 0 && (
          <div className="flex items-center justify-between px-6 pt-3 pb-4 border-t border-[#E5E8F3]">
            <span className="text-[14px] leading-5 font-OpenSansRegular text-[#868DA6]">
              Showing{" "}
              <span className="font-OpenSansSemiBold text-[#1A2332]">{(page - 1) * PAGE_SIZE + 1}</span> to{" "}
              <span className="font-OpenSansSemiBold text-[#1A2332]">{Math.min(page * PAGE_SIZE, roles.length)}</span>{" "}
              of <span className="font-OpenSansSemiBold text-[#1A2332]">{roles.length}</span> results
            </span>
            <div className="flex items-center gap-3">
              <button
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                className="px-[14px] py-2 rounded-[8px] bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-[#C9CEE2] text-[14px] leading-5 font-OpenSansSemiBold text-[#1A2332] disabled:outline-[#E5E8F3] disabled:text-[#C9CEE2]"
              >
                Previous
              </button>
              <div className="flex items-center gap-0.5">
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                  <button
                    key={p}
                    onClick={() => setPage(p)}
                    className={`w-10 h-10 rounded-[8px] text-[14px] leading-5 font-OpenSansSemiBold ${
                      p === page ? "bg-[#F5F9FF] text-[#0065FD]" : "text-[#868DA6] hover:bg-[#F5F9FF]"
                    }`}
                  >
                    {p}
                  </button>
                ))}
              </div>
              <button
                disabled={page === totalPages}
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                className="px-[14px] py-2 rounded-[8px] bg-white shadow-[0px_1px_2px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-[#C9CEE2] text-[14px] leading-5 font-OpenSansSemiBold text-[#1A2332] disabled:outline-[#E5E8F3] disabled:text-[#C9CEE2]"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      <CreateRoleModal shown={modalShown} role={editingRole} onClose={() => setModalShown(false)} onSaved={load} />

      {deleteTarget && (
        <ConfirmDialog
          title="DELETE ROLE"
          description={`Are you sure you want to delete "${deleteTarget.name}"?`}
          shown={!!deleteTarget}
          onConfirmClicked={confirmDelete}
          onCancelClicked={() => setDeleteTarget(null)}
        />
      )}
    </div>
  );
}

export default Roles;
